namespace SolovisGateway.Admin.DataEnvironments {

    export interface DataEnvironmentUserListControlOptions extends Solovis.UI.BaseControlOptions {
        dataEnvironmentId?: number;
        restrictedAdminUIEnabled: boolean;
    }

    export class DataEnvironmentUserListControl extends Solovis.UI.BaseControl {

        private _dataEnvironmentId: number;
        private _restrictedAdminUIEnabled: boolean;
        private _initError;
        private _users;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options: DataEnvironmentUserListControlOptions) {
            super(options);

            this._dataEnvironmentId = options.dataEnvironmentId;
            this._restrictedAdminUIEnabled = options.restrictedAdminUIEnabled;
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invoke(
                "~/DataEnvironment/GetEnvironmentUsers",
                { dataEnvironmentId: this._dataEnvironmentId },
                function (response, success) {
                    if (success) {
                        self._users = response.result.users;
                    }
                    else {
                        console.log("ERROR: DataEnvironmentUserListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            let self = this;

            // Setup action row
            let actionRowDiv = $("<div>").appendTo(this.container);

            let addUserLink = $("<a>").text("Add User")
                .click(function () {
                    self._showAddUser();
                })
                .appendTo(actionRowDiv);

            $("<span>").text(" | ").appendTo(actionRowDiv);

            let syncAllUsersLink = $("<a>").text("Sync All Users")
                .click(function () {
                    self._syncAllUsers();
                })
                .appendTo(actionRowDiv);

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._users
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'fullName'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },

                width: "100%",

                columns: [
                    {
                        dataField: 'fullName',
                        dataType: 'string',
                        caption: 'Full Name',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'primaryEmail',
                        dataType: 'string',
                        caption:  !self._restrictedAdminUIEnabled ?'Primary Email': "eVestment Username",  
                        allowSorting: true,
                        width: 200,
                    },
                    {
                        dataField: 'contactEmail',
                        dataType: 'string',
                        caption: 'Contact Email',
                        allowSorting: true,
                        width: 200,
                        visible: self._restrictedAdminUIEnabled
                    },
                    {
                        dataField: 'isEnvironmentAdmin',
                        dataType: 'boolean',
                        caption: 'Environment Admin',
                        allowSorting: true,
                        cellTemplate: function (container, options) {
                            let userData = options.data;
                            self._buildEnvironmentAdminCell(container, userData);
                        },
                        width: 150
                    },
                    {
                        dataField: 'code',
                        dataType: 'string',
                        visible: false,
                        caption: 'User Code',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'organizationName',
                        dataType: 'code',
                        visible: true,
                        caption: 'Organization Name',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let userData = options.data;
                            self._buildActionsCell(container, userData);
                        },
                        width: 100
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }


        private _buildEnvironmentAdminCell(container, userData) {
            let self = this;

            let checkboxDiv = $("<div>").appendTo(container).dxCheckBox({
                value: userData.isEnvironmentAdmin,
                readOnly: true
            });

            checkboxDiv.click(function () {
                self._showToggleUserEnvironmentAdmin(userData);
            });
        }

        private _buildActionsCell(container, userData) {
            let self = this;
            let columnDiv = container;

            let settingsLink = $("<a>").appendTo(columnDiv);
            $("<span class='fa fa-remove'>").appendTo(settingsLink);
            settingsLink.click(function () {
                self._showRemoveUser(userData);
            });

            let rolesLink = $("<a>").css("padding-left", "5px").appendTo(columnDiv);
            $("<span class='fa fa-user'>").appendTo(rolesLink);
            rolesLink.click(function () {
                self._showUserRoles(userData);
            });
        }


        private _showAddUser() {
            let self = this;

            var addUserDialog = new SolovisGateway.Admin.DataEnvironments.AddDataEnvironmentUserDialog({
                dataEnvironmentId: this._dataEnvironmentId,
                userAddedCallback: function () { self._refreshUsers(); }
            });
            addUserDialog.show();
        }

        private _showRemoveUser(userData) {
            let self = this;

            let removePromptDiv = $("<div>").text("Remove " + userData.fullName + " from environment?");

            Solovis.UI.confirm(removePromptDiv, "Remove User",
                function (confirmed) {
                    if (confirmed) {
                        Solovis.Rpc.invokeAndWait(
                            "~/DataEnvironment/RemoveUser",
                            { dataEnvironmentId: self._dataEnvironmentId, userId: userData.id },
                            function (response, success) {
                                if (response.result) {
                                    self._refreshUsers();
                                }
                            }
                        );
                    }
                });
        }

        private _showToggleUserEnvironmentAdmin(userData) {
            let self = this;

            let toggleRequest: any = {
                dataEnvironmentId: this._dataEnvironmentId,
                userId: userData.id,
                isEnvironmentAdmin: !userData.isEnvironmentAdmin
            };

            let promptText: string;
            if (userData.isEnvironmentAdmin) {
                promptText = "Remove environment admin role from " + userData.fullName + "?";
            }
            else {
                promptText = "Add environment admin role for " + userData.fullName + "?";
            }

            let promptDiv = $("<div>").text(promptText);

            Solovis.UI.confirm(promptDiv, "Environment Admin Change",
                function (confirmed) {
                    if (confirmed) {
                        Solovis.Rpc.invokeAndWait(
                            "~/DataEnvironment/SetEnvironmentAdminStatus",
                            toggleRequest,
                            function (response, success) {
                                if (response.result) {
                                    self._refreshUsers();
                                }
                            }
                        );
                    }
                });
        }

        private _syncAllUsers() {
            Solovis.Rpc.invokeAndWait(
                "~/DataEnvironment/SyncAllUsers",
                { id: this._dataEnvironmentId },
                function (response, success) {
                    if (response.result) {
                        Solovis.UI.alert("'Sync All Users' succeeded.");
                    }
                }
            );
        }

        private _showUserRoles(userData) {
            let self = this;

            let userRolesDialog = new EnvironmentUserRolesDialog(this._dataEnvironmentId, userData);
            userRolesDialog.show();
        }

        private _refreshUsers() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/DataEnvironment/GetEnvironmentUsers",
                { dataEnvironmentId: this._dataEnvironmentId },
                function (response, success) {
                    if (success) {
                        let users = response.result.users;
                        let store = new DevExpress.data.ArrayStore({ key: 'id', data: users });

                        self._dataGrid.option("dataSource", store);
                    }
                });
        }
    }

}